<template>
  <div class="rank-list">
    <div class="tabs-wrap">
      <div
        class="one-tab"
        :class="showRank === 0 && 'active'"
        @click="showRank = 0"
      >
        禮物榜
      </div>
      <div
        class="one-tab"
        :class="showRank === 1 && 'active'"
        @click="showRank = 1"
      >
        下單榜
      </div>
      <button
        class="show-detail"
        @click="
          showRankDetail = true;
          showAllRank = showRank;
        "
      >
        <span>詳情</span>
        <fps-icon type="arrow-right" size="15" />
      </button>
    </div>
    <div class="list-wrap">
      <div v-if="isLoading" class="rank-loading">
        <i class="el-icon-loading"></i>
      </div>
      <div v-else-if="!displayRank.length" class="empty-rank">
        <template v-if="showRank === 0">
          <img
            class="empty-gift"
            src="~@/assets/image/background/empty-gift.png"
          />
          <span>還沒有人送過禮物喔</span>
        </template>
        <template v-else>
          <img
            class="empty-gift"
            src="~@/assets/image/background/empty-order.png"
          />
          <span>還沒有人下過單喔</span>
        </template>
      </div>
      <div v-else class="rank-list-wrap">
        <div
          v-for="(r, i) in displayRank"
          :key="`${showRank ? 'order' : 'gift'}-${i}`"
          class="rank-one"
        >
          <div class="rank-no" :class="'rank-no-' + (i + 1)">{{ i + 1 }}</div>
          <fps-avatar
            class="rank-avatar"
            :src="r.avatarUrl"
            @click.native="openMasterDetail(r.userUuid)"
            :level="r.userLevel"
          />
          <div class="nickname">{{ r.nickname }}</div>
          <span class="rank-score">{{ r.score }}</span>
          <img
            v-if="showRank === 0"
            class="gold-img"
            src="~@/assets/image/icons/diamond.png"
          />
          <img
            v-else
            class="gold-img"
            src="~@/assets/image/icons/gold-icon.png"
          />
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="showRankDetail"
      class="dialog-clear-style-wrap"
      custom-class="dialog-clear-style"
      :show-close="false"
      width="375px"
      top="0"
      append-to-body
    >
      <div class="all-ranking">
        <fps-icon
          class="close-dialog pointer"
          type="close"
          size="24"
          color="#fff"
          @click.native="showRankDetail = false"
        />
        <div class="tabs-wrap">
          <div
            class="one-tab"
            :class="showAllRank === 0 && 'active'"
            @click="showAllRank = 0"
          >
            禮物榜
          </div>
          <div
            class="one-tab"
            :class="showAllRank === 1 && 'active'"
            @click="showAllRank = 1"
          >
            下單榜
          </div>
        </div>
        <div class="line" />
        <div class="list-wrap">
          <div v-if="isLoading" class="rank-loading">
            <i class="el-icon-loading"></i>
          </div>
          <div v-else-if="!displayAllRank.length" class="empty-rank">
            <template v-if="showAllRank === 0">
              <img
                class="empty-gift"
                src="~@/assets/image/background/empty-gift.png"
              />
              <span>還沒有人送過禮物喔</span>
            </template>
            <template v-else>
              <img
                class="empty-gift"
                src="~@/assets/image/background/empty-order.png"
              />
              <span>還沒有人下過單喔</span>
            </template>
          </div>
          <div v-else class="rank-list-wrap">
            <div
              v-for="(r, i) in displayAllRank"
              :key="`${showAllRank ? 'order' : 'gift'}-${i}`"
              class="rank-one"
              :class="'rank-one-' + (i + 1)"
            >
              <div class="rank-no">{{ i + 1 }}</div>
              <fps-avatar
                class="rank-avatar"
                :src="r.avatarUrl"
                @click.native="openMasterDetail(r.userUuid)"
                :level="r.userLevel"
              />
              <div class="nickname">{{ r.nickname }}</div>
              <span class="rank-txt">送出</span>
              <div class="score-wrap">
                <span class="rank-score">{{ r.score }}</span>
                <img
                  v-if="showAllRank === 0"
                  class="gold-img"
                  src="~@/assets/image/icons/diamond.png"
                />
                <img
                  v-else
                  class="gold-img"
                  src="~@/assets/image/icons/gold-icon.png"
                />
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="
            !isLoading &&
              showAllRank === 0 &&
              (!userInfo || userInfo.uuid !== masterUuid)
          "
          class="bottom-info"
        >
          <div
            v-if="userInfo"
            class="rank-no"
            :class="
              selfScore < 3 && selfScore > -1 && 'rank-no-' + (selfScore + 1)
            "
          >
            {{ selfScore === -1 ? '--' : selfScore + 1 }}
          </div>
          <fps-avatar
            v-if="userInfo"
            class="rank-avatar"
            :src="
              selfScore === -1
                ? userInfo.avatarUrl
                : giftRank[selfScore].avatarUrl
            "
          />
          <div v-if="userInfo" class="nickname">
            <span class="my-nickname">我</span>
            <div :class="selfScore === -1 && 'font-stronger'">
              {{
                selfScore === 0
                  ? '恭喜您目前排位第一'
                  : selfScore === -1
                  ? '還沒有送出禮物'
                  : `距離上一名還差`
              }}<span>{{
                selfScore > 0
                  ? giftRank[selfScore - 1].score -
                    giftRank[selfScore].score +
                    1
                  : ''
              }}</span>
            </div>
          </div>
          <div v-else class="nickname" />
          <el-popover
            v-model="showSendGift"
            placement="top-start"
            title="禮物"
            width="399"
            trigger="click"
            class="send-gifts one-btn"
            popper-class="send-gifts-popover"
          >
            <fps-icon
              class="close-popover"
              type="close"
              @click.native="showSendGift = false"
            />
            <SendGift
              ref="send_gift"
              startPadding="2.5px 7.5px"
              :playerUserUuid="masterUuid"
              :success="sendGiftSuccess"
            />
            <div slot="reference" class="to-send-gift">
              <img src="~@/assets/image/icons/gift-btn.png" />
              <span>送禮</span>
            </div>
          </el-popover>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import SendGift from '@/components/SendGifts';
export default {
  components: {
    SendGift
  },
  props: {
    masterUuid: {
      type: String,
      require: true
    }
  },
  data() {
    return {
      showRank: 0,
      giftRank: [],
      orderRank: [],
      isLoading: false,
      showRankDetail: false,
      showAllRank: 0,
      showSendGift: false
    };
  },
  computed: {
    ...mapGetters(['userInfo']),
    displayRank() {
      const displayRank = this.showRank === 0 ? this.giftRank : this.orderRank;
      if (displayRank.length > 5) return displayRank.slice(0, 5);
      return displayRank;
    },
    displayAllRank() {
      return this.showAllRank === 0 ? this.giftRank : this.orderRank;
    },
    selfScore() {
      if (this.showAllRank !== 0 || !this.userInfo) return undefined;
      else {
        return this.giftRank.findIndex(
          item => item.userUuid === this.userInfo.uuid
        );
      }
    }
  },
  watch: {
    masterUuid() {
      this.getRankList();
    }
  },
  created() {
    this.getRankList();
  },
  methods: {
    sendGiftSuccess(gift) {
      this.showSendGift = false;
      this.$emit('sendgiftsuccess', gift);
    },
    openMasterDetail(userUuid) {
      this.$router.push({
        path: `/player-detail/${userUuid}`
      });
    },
    getRankList() {
      if (!this.masterUuid) return;
      this.isLoading = true;
      Promise.all([this.getGiftRank(), this.getOrderRank()])
        .then(([giftRank]) => {
          if (!giftRank.length) this.showRank = 1;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    getGiftRank() {
      return this.$http
        .post('/gift/rank', {
          playerUserUuid: this.masterUuid,
          rankKind: 'PlayerSendGiftRank'
        })
        .then(({ data: giftRank }) => {
          this.giftRank = giftRank;
          return giftRank;
        });
    },
    getOrderRank() {
      return this.$http
        .post('/gift/rank', {
          playerUserUuid: this.masterUuid,
          rankKind: 'PlayerSendOrderRank'
        })
        .then(({ data: orderRank }) => {
          this.orderRank = orderRank;
          return orderRank;
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.dialog-clear-style-wrap /deep/ .dialog-clear-style {
  max-width: 100vw;
}
.rank-list {
  padding: 12px 24px 32px;
  .tabs-wrap {
    height: 44px;
    display: flex;
    justify-content: flex-start;
    position: relative;
    .show-detail {
      position: absolute;
      top: 50%;
      right: 0;
      @include flex;
      transform: translateY(-50%);
      font-size: 15px;
      line-height: 20px;
      color: $color-gray-3;
      &:hover {
        opacity: 0.5;
      }
    }
    .one-tab {
      @include flex;
      position: relative;
      font-size: 15px;
      line-height: 22px;
      color: $color-gray-3;
      cursor: pointer;
      &:not(:first-child) {
        margin-left: 12px;
      }
      &.active {
        font-weight: 500;
        font-size: 17px;
        color: $color-gray-1;
        &::before {
          content: '';
          width: 12px;
          height: 4px;
          position: absolute;
          left: 50%;
          bottom: 0;
          transform: translate(-50%);
          border-radius: 4px;
          background: $color-yellow;
        }
      }
    }
  }
  .rank-list-wrap {
    padding-top: 8px;
    .rank-one {
      width: 100%;
      margin-top: 24px;
      @include flex;
      .rank-no {
        width: 27px;
        text-align: center;
        font-size: 14px;
        color: $color-gray-3;
        &.rank-no-1 {
          color: #ffc000;
        }
        &.rank-no-2 {
          color: #83ceff;
        }
        &.rank-no-3 {
          color: #fd9536;
        }
      }
      .rank-avatar {
        width: 32px;
        height: 32px;
        margin-left: 12px;
      }
      .nickname {
        font-size: 12px;
        line-height: 1;
        color: $color-gray-1;
        margin-left: 8px;
        flex: 1;
      }
      .rank-score {
        font-weight: 600;
        font-size: 12px;
        line-height: 1;
        color: $color-gray-1;
      }
      .gold-img {
        margin-left: 2px;
        width: 16px;
      }
    }
  }
}
.rank-loading {
  height: 150px;
  @include flex;
  font-size: 24px;
}
.empty-rank {
  height: 150px;
  @include flex;
  flex-direction: column;
  font-size: 14px;
  line-height: 21px;
  color: $color-gray-3;
  .empty-gift {
    height: 70px;
    margin-bottom: 18px;
  }
}
.all-ranking {
  width: 375px;
  background: #ffffff;
  border-radius: 4px;
  margin: 50px auto 0;
  padding: 16px 0 80px;
  position: relative;
  .close-dialog {
    position: absolute;
    top: 0px;
    right: -16px;
    transform: translate(100%);
  }
  .line {
    width: 100%;
    height: 1px;
    margin-top: 4px;
    background: $color-button;
  }
  .list-wrap {
    padding: 0 16px;
  }
  .tabs-wrap {
    height: 44px;
    display: flex;
    justify-content: flex-start;
    padding: 0 24px;
    .one-tab {
      @include flex;
      position: relative;
      font-size: 14px;
      line-height: 20px;
      color: $color-gray-3;
      cursor: pointer;
      &:not(:first-child) {
        margin-left: 12px;
      }
      &.active {
        font-weight: 500;
        color: $color-gray-1;
        &::before {
          content: '';
          width: 12px;
          height: 4px;
          position: absolute;
          left: 50%;
          bottom: 0;
          transform: translate(-50%);
          border-radius: 4px;
          background: $color-yellow;
        }
      }
    }
  }
  .rank-list-wrap {
    padding-top: 12px;
    max-height: 414px;
    overflow-y: auto;
    @include hideScrollBar(0, 0);
    .rank-one {
      width: 100%;
      &:not(:first-child) {
        margin-top: 24px;
      }
      @include flex;
      .rank-no {
        width: 27px;
        text-align: center;
        font-size: 14px;
        color: $color-gray-3;
      }
      .rank-avatar {
        width: 40px;
        height: 40px;
        margin-left: 12px;
      }
      .nickname {
        font-size: 14px;
        color: $color-gray-1;
        margin-left: 12px;
        flex: 1;
      }
      .rank-txt {
        font-size: 13px;
        color: $color-gray-2;
      }
      .score-wrap {
        @include flex;
        margin-left: 2px;
      }
      .rank-score {
        font-weight: 500;
        font-size: 14px;
        color: $color-gray-1;
      }
      .gold-img {
        margin-left: 2px;
        width: 18px;
      }
      &.rank-one-1 {
        .rank-no {
          color: #ffc000;
        }
        .score-wrap {
          padding: 2px 2px 2px 4px;
          background: linear-gradient(-90deg, #f45e9e 6.1%, #f5816f 92.73%);
          border-radius: 20px;
        }
        .rank-score {
          color: #fff;
        }
      }
      &.rank-one-2 {
        .rank-no {
          color: #ffc000;
        }
        .score-wrap {
          padding: 3px 2px 2px 4px;
          background: linear-gradient(-90deg, #f45e9e 6.1%, #f5816f 92.73%);
          border-radius: 20px;
        }
        .rank-score {
          color: #fff;
        }
      }
      &.rank-one-3 {
        .rank-no {
          color: #83ceff;
        }
        .score-wrap {
          padding: 2px 2px 2px 4px;
          background: linear-gradient(-90deg, #f45e9e 6.1%, #f5816f 92.73%);
          border-radius: 20px;
        }
        .rank-score {
          color: #fff;
        }
      }
    }
  }
}
.bottom-info {
  box-shadow: 0px 0px 8px rgba(178, 178, 178, 0.191718);
  width: 100%;
  height: 64px;
  padding: 0 16px;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  @include flex;
  .rank-no {
    width: 18px;
    text-align: center;
    font-size: 14px;
    color: $color-gray-3;
    &.rank-no-1 {
      color: #ffc000;
    }
    &.rank-no-2 {
      color: #83ceff;
    }
    &.rank-no-3 {
      color: #fd9536;
    }
  }
  .rank-avatar {
    width: 40px;
    height: 40px;
    margin-left: 12px;
  }
  .nickname {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-left: 12px;
    div {
      font-size: 13px;
      line-height: 18px;
      color: $color-gray-2;
      letter-spacing: -0.3px;
    }
    .my-nickname {
      font-weight: 500;
      font-size: 16px;
      line-height: 20px;
      color: $color-gray-2;
      span {
        font-weight: 500;
        color: $color-gray-1;
      }
    }
  }
  .to-send-gift {
    width: 101px;
    height: 40px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50px;
    background: $color-gray-1;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 1px;
    color: #ffffff;
    img {
      width: 22px;
      margin-right: 8px;
    }
  }
}
</style>
